





























































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'form', 'meta',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      client_id: { required },
      name: { required, minLength: minLength(3) },
      position: {},
      credentials: {},
      sun: {},
      mon: {},
      tue: {},
      wed: {},
      thu: {},
      fri: {},
      sat: {},
      contacts: {},
      role: {},
    }

    // @ts-ignore
    if (this.form && this.form.credentials) {
      rules.credentials = {
        login: {
          required: requiredIf(function(nestedModel) {
            return nestedModel
          })
        },
        password: {
          required: requiredIf(function(nestedModel) {
            return (nestedModel && !nestedModel.encrypted_password)
          })
        },
        repeatPassword: {
          sameAsPassword: sameAs(function(nestedModel: any, vm: any) {
            return nestedModel ? nestedModel.password : null;
          })
        }
      }

      rules.roles = {}
    }

    return {
      form: rules
    }
  }
})
export default class PersonForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any
  form!: any

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  toggleCredentials(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/toggleCredentials`);

    if (this.$v.form.credentials) {
      // @ts-ignore
      this.$v.form.credentials.$touch();
    }

    // this.$v.form.$touch();
  }

  changeCredentialsValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeCredentialsValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form.credentials[field].$touch();
    // this.$v.form.$touch();
  }

  toggleRoleSelection(roleId: string) {
    this.$store.dispatch(`${STORE_KEY}/toggleRoleSelection`, roleId);

    if (this.$v.form.roles) {
      this.$v.form.roles.$touch();
    }

    // this.$v.form.$touch();
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  setArchive() {
    this.$store.dispatch(`${STORE_KEY}/setArchive`)
    .then((result) => {
        this.$buefy.snackbar.open(`Записть архивирована`);

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch((e) => {
        console.log(e)
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
  }

  setUnarchive() {
    this.$store.dispatch(`${STORE_KEY}/setUnarchive`)
    .then(() => {
        this.$buefy.snackbar.open(`Записть активирована`);

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })    
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

